export default {
  setLang: (state, lang) => {
    state.lang = lang;
  },
};
